export default __webpack_public_path__ + "static/media/SCS-icon-8-2-22.0a0de957.svg";